import { render, staticRenderFns } from "./Facturas.vue?vue&type=template&id=39f048c2&scoped=true&"
import script from "./Facturas.vue?vue&type=script&lang=js&"
export * from "./Facturas.vue?vue&type=script&lang=js&"
import style0 from "./Facturas.vue?vue&type=style&index=0&id=39f048c2&prod&lang=scss&scoped=true&"
import style1 from "./Facturas.vue?vue&type=style&index=1&id=39f048c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f048c2",
  null
  
)

export default component.exports